import { useEffect, useState } from 'react'
import { LoginPage } from '@/pages/Login'

export function AuthGate({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<'checking' | 'authed' | 'unauthed'>('checking')

  useEffect(() => {
    fetch('/api/auth/status', { credentials: 'include' })
      .then((r) => r.json() as Promise<{ authenticated: boolean }>)
      .then((d) => setState(d.authenticated ? 'authed' : 'unauthed'))
      .catch(() => setState('unauthed'))
  }, [])

  if (state === 'checking') {
    return <div className="min-h-screen w-full flex flex-col items-center justify-center bg-surface-page gap-3">
    <div className="w-6 h-6 border-2 border-ink-tertiary border-t-transparent rounded-full animate-spin" />
    <div className="text-ink-tertiary text-sm">Loading…</div>
  </div>
  }
  if (state === 'unauthed') {
    return <LoginPage onSuccess={() => setState('authed')} />
  }
  return <>{children}</>
}
